/* ===========================================================
 * 
 *   Predictive Search Controller. 
 * 
 *   Provides predictive search funtionality, including:
 *
 *      - search field change listener
 *      - ajax loading and displaying of search results
 *      - arrow-key control of the results list
 *      - esc key control to hide the results list
 * 
 * ===========================================================*/


( function() {

    var container, body, input, results, i, len;

    /**
     * When the input field is focused, add a focus class
     * to the parent container
     */
    var toggleSearchFocus = function() {
        
        //  If it is already focused, remove the class
        if ( -1 !== container.className.indexOf( 'focus' ) ) {
            container.className = container.className.replace( ' focus', '' );
        } 
        
        //  If it is not already focused, add the class
        else {
            container.className += ' focus';
            results.style.display = 'block';
        }
    };

    /**
     * When the search results load, init the keydown listeners.
     * 
     * Adds the listeners to handle the up/down arrow 
     * key functionality. This will change focus on the 
     * previous or next search result item.
     * 
     * Also listens for the escape key to hide the search
     * results
     */
    var initKeyListeners = function() {
        
        //  Note the first item
        first = results.firstChild;

        //  Listen for the keydown
        document.onkeydown = function(evt) { 

            //  Get the event
            evt = evt || window.event;

            //  Was it an escape key?
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key === "Escape" || evt.key === "Esc");
            } else {
                isEscape = (evt.keyCode === 27);
            }

            //  Yes - hide the results
            if (isEscape) {
                results.style.display = 'none';
                input.blur();
                return;
            }
            
            //  Was it the up key?
            if ((evt.keyCode === 38)) {
                if (document.activeElement == (input || first)) { 
                    return; 
                } 
                else { 
                    if (document.activeElement.previousSibling) {
                        document.activeElement.previousSibling.focus(); 
                    }
                }
            }
            
            //  Was it the down key?
            if ((evt.keyCode === 40)) {
                if (document.activeElement == input) { 
                    first.focus(); 
                } 
                else { 
                    if (document.activeElement.nextSibling) {
                        if ( -1 !== document.activeElement.nextSibling.className.indexOf( 'search-result-item' ) ) {
                            document.activeElement.nextSibling.focus(); 
                        }
                    }
                } 
            }
        }
    };

    /**
     * Run the ajax search, and display the results. Once loaded
     * init the key listeners 
     * 
     * @param {string} search_text
     */
    var doSearch = function( search_text ) {
        
        //  Clear the previous results
        results.innerHTML = '';

        //  Add a loading class
        results.classList.add('loading');
        
        //  Build the data to send
        var ajax_url = nfAjax.ajaxurl;
        var ajax_data = {
            action: 'ajax_search', 
            search_string: search_text
        };

        //  Do the search
        ajax.get(ajax_url, ajax_data, function( response ) {

            //  Load the results
            results.innerHTML = response;
            results.style.display = 'block';

            //  Init the key listeners
            initKeyListeners();
        });
    };

    /**
     * Init the search functionality
     */
    /*
    var init = function() {

        //  Get the container container
        container = document.getElementById( 'search-container' );
        if ( 'undefined' === typeof container ) {
            return;
        }

        //  Get the page body
        body = document.getElementsByTagName( 'body' )[0];
        if ( 'undefined' === typeof body ) {
            return;
        }

        //  Get the search input
        input = document.getElementById( 'search-input' );
        if ( 'undefined' === typeof input ) {
            return;
        }

        //  Get the results container
        results = document.getElementById( 'search-results' );
        if ( 'undefined' === typeof results ) {
            return;
        }

        input.addEventListener( 'focus', toggleSearchFocus, true );
        input.addEventListener( 'blur', toggleSearchFocus, true );

        input.onclick = function(evt) {
            evt.stopPropagation();
        }

        body.onclick = function(evt) {
            container.className = container.className.replace( ' focus', '' );
            results.style.display = 'none';
            input.blur();
        }

        //  When the search input changes, load the search results
        let delayTimer;
        input.onkeyup = function(evt) {
        
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key === "Escape" || evt.key === "Esc");
            } else {
                isEscape = (evt.keyCode === 27);
            }

            if (isEscape) {
                console.log( 'escape' );
                results.style.display = 'none';
                input.blur();
                return;
            }

            //  If there is an input value, do the search
            if (input.value) {
                clearTimeout(delayTimer);
                delayTimer = setTimeout(function() {
                    doSearch( input.value );
                }, 150);
            }
        };
    };
    */

    /**
	 * Makes an ajax request
	 */
    var ajax = {};
    ajax.x = function () {
        if (typeof XMLHttpRequest !== 'undefined') {
            return new XMLHttpRequest();
        }
        var versions = [
            "MSXML2.XmlHttp.6.0",
            "MSXML2.XmlHttp.5.0",
            "MSXML2.XmlHttp.4.0",
            "MSXML2.XmlHttp.3.0",
            "MSXML2.XmlHttp.2.0",
            "Microsoft.XmlHttp"
        ];

        var xhr;
        for (var i = 0; i < versions.length; i++) {
            try {
                xhr = new ActiveXObject(versions[i]);
                break;
            } catch (e) {
            }
        }
        return xhr;
    };

    ajax.send = function (url, callback, method, data, async) {
        if (async === undefined) {
            async = true;
        }
        var x = ajax.x();
        x.open(method, url, async);
        x.onreadystatechange = function () {
            if (x.readyState == 4) {
                callback(x.responseText)
            }
        };
        if (method == 'POST') {
            x.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        }
        x.send(data)
    };

    ajax.get = function (url, data, callback, async) {
        var query = [];
        for (var key in data) {
            query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
        }
        ajax.send(url + (query.length ? '?' + query.join('&') : ''), callback, 'GET', null, async)
    };

    ajax.post = function (url, data, callback, async) {
        var query = [];
        for (var key in data) {
            query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
        }
        ajax.send(url, callback, 'POST', query.join('&'), async)
    };

    // init();

} )();
